var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isInactive)?_c('div',{staticClass:"inactive-tag"},[_c('span',{staticClass:"font-semibold rounded-full bg-cadet-blue px-2"},[_vm._v(" "+_vm._s(_vm.$translate('app.inactive'))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }